import React from 'react';

const ArrowRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M10.2861 6.02515L15.741 11.48C16.0757 11.8147 16.0757 12.3574 15.741 12.6922L10.2861 18.147"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default ArrowRight;
